export const dashboardIt = {
  // condiviso — DashboardNav
  'dashboard.nav.ariaLabel': 'Sezioni dashboard',
  'dashboard.nav.overview': 'Panoramica',
  'dashboard.nav.avatar': 'Avatar',
  'dashboard.nav.coins': 'Monete',
  'dashboard.nav.contributions': 'Contributi',

  // condiviso — StatusBadge (stato contributo)
  'dashboard.status.draft': 'Bozza',
  'dashboard.status.submitted': 'Inoltrato',
  'dashboard.status.communityReview': 'Revisione Comunità',
  'dashboard.status.officialReview': 'Revisione Ufficiale',
  'dashboard.status.approved': 'Approvato',
  'dashboard.status.rejected': 'Rigettato',
  'dashboard.status.unknown': 'sconosciuto',

  // condiviso — ClaimStatusBadge
  'dashboard.claimStatus.pending': 'in sospeso',
  'dashboard.claimStatus.approved': 'approvato',
  'dashboard.claimStatus.rejected': 'rigettato',

  // DashboardPage
  'dashboard.seo.title': 'Il Mio Grymwyrd',
  'dashboard.seo.description': 'Le tue monete, reclami, contributi e personaggi nel crepuscolo eterno.',
  'dashboard.displayNameFallback': 'Viandante',
  'dashboard.welcomeBack': 'Bentornato',
  'dashboard.editAvatar': 'Modifica avatar',
  'dashboard.loading': 'Raccogliendo la tua leggenda…',
  'dashboard.avatarAlt': 'Ritratto di {name}',
  'dashboard.offlineNotice':
    'I dati del profilo live non sono disponibili — mostriamo la tua ultima sessione nota e contenuti campione.',

  // DashboardPage — Carta monete
  'dashboard.coins.title': 'Monete Sepolcrali',
  'dashboard.coins.viewAll': 'Vedi tutto',
  'dashboard.coins.unit': 'monete',
  'dashboard.coins.noActivity': 'Nessuna attività di monete ancora.',
  'dashboard.coins.fullHistory': 'Cronologia completa e acquista monete',

  // DashboardPage — Carta contributi
  'dashboard.contributions.title': 'Contributi',
  'dashboard.contributions.manage': 'Gestisci',
  'dashboard.contributions.empty': 'Nessun contributo ancora — scrivi il primo.',

  // DashboardPage — Carta reclami
  'dashboard.claims.title': 'Terreni Reclamati in Grymwyrd',
  'dashboard.claims.empty': 'Non possiedi ancora terreno in Grymwyrd.',
  'dashboard.claims.kindClaimed': '{kind} · reclamato {date}',

  // DashboardPage — Carta personaggi
  'dashboard.characters.title': 'Personaggi',
  'dashboard.characters.empty': 'Nessuna anima legata al tuo nome.',
  'dashboard.characters.level': 'Liv {level}',
  'dashboard.characters.unknown': 'Sconosciuto',

  // AvatarEditorPage
  'dashboard.avatarEditor.seo.title': 'Editor Avatar',
  'dashboard.avatarEditor.seo.description': 'Modella il volto che mostri al mondo di Grymwyrd.',
  'dashboard.avatarEditor.heading': 'Editor Avatar',
  'dashboard.avatarEditor.errorNotImage': 'Quel file non è un\'immagine.',
  'dashboard.avatarEditor.errorNameRequired': 'Un nome è richiesto, anche nel buio.',
  'dashboard.avatarEditor.portrait': 'Ritratto',
  'dashboard.avatarEditor.portraitPreview': 'Anteprima ritratto',
  'dashboard.avatarEditor.avatarPreviewAlt': 'Anteprima avatar',
  'dashboard.avatarEditor.zoom': 'Zoom',
  'dashboard.avatarEditor.zoomAria': 'Zoom ritratto',
  'dashboard.avatarEditor.panHorizontal': 'Scorri ritratto orizzontalmente',
  'dashboard.avatarEditor.panVertical': 'Scorri ritratto verticalmente',
  'dashboard.avatarEditor.uploadAria': 'Carica immagine ritratto',
  'dashboard.avatarEditor.changeImage': 'Cambia immagine',
  'dashboard.avatarEditor.uploadImage': 'Carica immagine',
  'dashboard.avatarEditor.identity': 'Identità',
  'dashboard.avatarEditor.displayName': 'Nome visualizzato',
  'dashboard.avatarEditor.backstory': 'Background',
  'dashboard.avatarEditor.backstoryPlaceholder': 'Da dove sei venuto, e quale oscuro destino persegui?',
  'dashboard.avatarEditor.publicProfile': 'Profilo pubblico',
  'dashboard.avatarEditor.publicVisible': 'Visibile nella Hall of Legends.',
  'dashboard.avatarEditor.publicHidden': 'Nascosto agli altri viandanti.',
  'dashboard.avatarEditor.saving': 'Salvataggio…',
  'dashboard.avatarEditor.saveChanges': 'Salva modifiche',
  'dashboard.avatarEditor.saved': 'Salvato',

  // CoinHistoryPage
  'dashboard.coinHistory.checkoutUnavailable': 'Il checkout non è ancora disponibile — i forzieri rimangono chiusi.',
  'dashboard.coinHistory.notEnoughCoins': 'Non abbastanza monete per questo.',
  'dashboard.coinHistory.reasonWorldClaim': 'Reclamo territoriale',
  'dashboard.coinHistory.reasonCosmetic': 'Cosmetico',
  'dashboard.coinHistory.spendReason': '{category} — {name}',
  'dashboard.coinHistory.spentNotice': 'Speso {cost} monete per {name}.',
  'dashboard.coinHistory.seo.title': 'Monete Sepolcrali',
  'dashboard.coinHistory.seo.description': 'Il tuo registro di monete completo, ricariche e le merci dei morti.',
  'dashboard.coinHistory.heading': 'Monete Sepolcrali',
  'dashboard.coinHistory.balance': 'bilancio',
  'dashboard.coinHistory.buyCoins': 'Acquista Monete',
  'dashboard.coinHistory.packCoins': '{coins} monete',
  'dashboard.coinHistory.packBonus': ' + {bonus} bonus',
  'dashboard.coinHistory.summoningCheckout': 'Invocando il checkout…',
  'dashboard.coinHistory.purchase': 'Acquista',
  'dashboard.coinHistory.spendCoins': 'Spendi Monete',
  'dashboard.coinHistory.insufficientCoins': 'Monete insufficienti',
  'dashboard.coinHistory.spending': 'Spendendo…',
  'dashboard.coinHistory.spendAmount': 'Spendi {cost}',
  'dashboard.coinHistory.historyTitle': 'Cronologia',
  'dashboard.coinHistory.tallyingLedger': 'Sommando il registro…',
  'dashboard.coinHistory.tableCaption': 'Cronologia transazioni monete',
  'dashboard.coinHistory.colReason': 'Motivo',
  'dashboard.coinHistory.colAmount': 'Importo',
  'dashboard.coinHistory.noTransactions': 'Nessuna transazione ancora.',

  // ContributionsPage
  'dashboard.contributionsPage.seo.title': 'I Miei Contributi',
  'dashboard.contributionsPage.seo.description':
    'La leggenda che hai scritto, e il suo passaggio attraverso lo sguardo dei moderatori.',
  'dashboard.contributionsPage.heading': 'Contributi',
  'dashboard.contributionsPage.newContribution': 'Nuovo Contributo',
  'dashboard.contributionsPage.loading': 'Srotolando i tuoi pergameni…',
  'dashboard.contributionsPage.empty': 'Non hai ancora scritto alcuna leggenda. Inizia il tuo primo contributo.',
  'dashboard.contributionsPage.untitledDraft': 'Bozza senza titolo',
  'dashboard.contributionsPage.moderator': 'Moderatore:',
  'dashboard.contributionsPage.entryFallback': 'Voce',
  'dashboard.contributionsPage.errorNameRequired': 'Ogni creazione ha bisogno di un nome.',
  'dashboard.contributionsPage.modalTitle': 'Nuovo Contributo',
  'dashboard.contributionsPage.type': 'Tipo',
  'dashboard.contributionsPage.titleLabel': 'Titolo',
  'dashboard.contributionsPage.summaryLabel': 'Riassunto',
  'dashboard.contributionsPage.saveDraft': 'Salva bozza',
  'dashboard.contributionsPage.submitting': 'Inoltando…',
  'dashboard.contributionsPage.submitForReview': 'Inoltro per revisione',
}
